import {
  AnalyticsEvent,
  Tracker,
  CommonPayload,
  isPaymentEvent,
  GtmBookAppointmentEventPayload,
} from '@water-web/view';

import { config } from '@app/config';

export class BarberCoTracker implements Tracker {
  brandId = '3a9badf3-3d9d-407d-abd0-209959b511ab';
  gclidMixin: Pick<GtmBookAppointmentEventPayload, 'gclid'> = { gclid: '' };

  constructor() {
    if (typeof window !== 'undefined') {
      const gclid = new URLSearchParams(window.location.search).get('gclid');
      if (gclid) {
        this.gclidMixin = { gclid };
      }
    }
  }

  getName(): string {
    return 'BarberCoTracker';
  }

  track(analyticsEvent: AnalyticsEvent, payload: CommonPayload): void {
    const exit = config.deploymentEnv !== 'production' || payload?.brandId !== this.brandId;

    if (exit || !isPaymentEvent(analyticsEvent, payload)) {
      return;
    }

    if (!payload.shopName || !payload.shopRoute) {
      console.error('Missing shop information in analytics payload. This should not happen');
      return;
    }

    const totalWithDecimals = (payload.totalWithTips / 100).toFixed(2);

    window.barberCoDataLayer?.push(<GtmBookAppointmentEventPayload>{
      event: 'booking',
      value: totalWithDecimals,
      currency: payload.currency,
      transaction_id: payload.appointmentId,
      shop_name: payload.shopName,
      shop_route: payload.shopRoute,
      ...this.gclidMixin,
    });
  }
}
